import React from 'react';
// import Card from '../../Components/Containers/Card';
import Loading from '../../Components/Loading';

const Authenticating = () => {

    return <>
        {/* <img src="/logo-name-horizontal.png"
            alt="getSoapy Logo"
            width="888"
            height="183"
            className="w-[75%] h-auto mx-auto mb-8"
        /> */}

        {/* <Card> */}
            <Loading size="2x" center />
        {/* </Card> */}
    </>;
}

export default Authenticating;